<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-menu-button auto-hide="false" data-test="sidemenuButton"></ion-menu-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Settings</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="more" [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>

        <ion-item [disabled]=vb.disabled detail="true" (click)="onUserProfileClick()" href="javascript:;" data-test="user">
            <ion-label class="ion-text-wrap">
                <span class="line1">My User Profile</span><br />
                <span class="line2">My personal settings.</span>
            </ion-label>
        </ion-item>

        <!-- @if (debugMode) {
  <ion-item [disabled]=vb.disable id="btnCache" detail="true" routerDirection="forward" routerLink="/settingsCacheCreds/">
            <ion-label class="ion-text-wrap">
                <span class="line1">Cache Login Credentials</span><br />
                <span class="line2">This will make logging in easier.</span>
            </ion-label>
        </ion-item>
} -->
    </ion-list>
</ion-content>